import React, { useId } from 'react'
import PropTypes from 'prop-types'

const KeyIcon = React.forwardRef(function KeyIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 13C6.34315 13 5 14.3431 5 16C5 17.6569 6.34315 19 8 19C9.65685 19 11 17.6569 11 16C11 14.3431 9.65685 13 8 13ZM3 16C3 13.2386 5.23858 11 8 11C10.7614 11 13 13.2386 13 16C13 18.7614 10.7614 21 8 21C5.23858 21 3 18.7614 3 16Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289L20.7071 9.29289C21.0976 9.68342 21.0976 10.3166 20.7071 10.7071C20.3166 11.0976 19.6834 11.0976 19.2929 10.7071L16.2929 7.70711C15.9024 7.31658 15.9024 6.68342 16.2929 6.29289Z"
      ></path>
    </svg>
  )
})

KeyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

KeyIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default KeyIcon
